(function () {
  'use strict';
  angular.module('vctracker')
    .component('trackersearch', {
      restrict: 'E',
      bindings: {
        tracker: '<',
        trackerref: '<',
        parentsave: '&?',
        editinplace: '@?',
        hideaddoption: '@?'
      },
      template: `
        <div class="form-group">
          <div class="input-group">
                <input type="text" class="form-control" tabindex="0"
                   ng-class="{'dirtyfield': vm.asyncSelected.length > 0}"
                   autofocus
                   placeholder="Kürzel"
                   ng-model="vm.asyncSelected"
                   typeahead-on-select="$parent.$dismiss();vm.showtracker($item, $model, $label)"
                   uib-typeahead="tracker as tracker.text for tracker in vm.getTrackers($viewValue)"
                   typeahead-loading="loadingNames"
                   typeahead-no-results="noResults">
            <span class="input-group-btn">
              <button type="submit"
                      ng-class="{'btn-warning': noResults, 'btn-info': !noResults}"
                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>
            </span>
          </div>
        </div>
        
        
        <i ng-show="loadingNames" class="glyphicon glyphicon-refresh"></i>
        <div ng-show="noResults">
          <i class="glyphicon glyphicon-remove"></i> Kein Tracker gefunden
          <span class="btn btn-success" ng-click="vm.addTracker()" ng-hide="vm.error">Neuen Tracker anlegen</span>
          <span ng-click="vm.addTracker()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Tracker konnte nicht angelegt werden!</span>
        </div>
        
        <div ng-show="(vm.editinplace === true || vm.editinplace === 'true') && vm.tracker">
          <trackereditor tracker="vm.tracker"></trackereditor>
        </div>
        
        
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Tracker', 'TrackerHelper',
        function ($log, Tracker, TrackerHelper) {
          let vm = this;
          vm.save = save;
          vm.showtracker = showtracker;

          vm.getTrackers = getTrackers;
          // vm.addTracker = TrackerHelper.addTracker;
          vm.addTracker = addTracker;
          vm.editTracker = TrackerHelper.editTracker;

          vm.$onInit = function () {
            vm.newtracker = {};

            if (angular.isDefined(vm.hideaddoption) && vm.hideaddoption === 'true') {
              vm.hideaddoption = true;
            }

            vm.lasttracker = angular.copy(vm.trackerresult);
            vm.lasttrackerref = angular.copy(vm.trackerref);
          };

          function addTracker() {
            $log.debug('debug - trackersearch addTracker called');
            TrackerHelper.addTracker(function (tracker) {
              $log.debug('debug: handle newly create tracker');
              vm.tracker = {};
              vm.tracker.name = tracker.name;
              vm.tracker.name = tracker.name;
              vm.tracker.def = tracker.def;
              vm.trackerref = tracker._id;
              vm.asyncSelected = tracker.short;
              vm.parentsave({tracker: vm.tracker, trackerref: vm.trackerref});
            }, function (err) {
              vm.error = true;
              $log.error(err);
            });
          }

          // typeahead tracker search backend query
          function getTrackers(val) {
            // return Trackerahead.$search({query: val}).$asPromise().then(function (response) {
            return Tracker.$searchahead({
              query: val,
              fields: ['name', 'def.0.label', 'def.1.label', 'def.2.label']}).$asPromise().then(function (response) {
              return response.map(function (tracker) {
                tracker.text = tracker.name;
                if (tracker.def.length > 1) {
                  let labels = '';
                  tracker.def.map(function (d) {
                    labels += d.label;
                    labels += ', ';
                  });
                  labels = labels.substring(0, labels.length -2);
                  tracker.text += ' (' + labels + ')';
                }
                delete vm.error;
                return tracker;
              });
            });
          }

          // typeahead tracker search action
          function showtracker($item, $model, $label) {
            /* jshint unused:false */
            /* eslint "no-unused-lets": [2, {"args": "none"}] */
            vm.tracker = $model;
            vm.trackerref = $model._id;
            delete vm.asyncSelected;
            if (vm.editinplace === true || vm.editinplace === 'true') {
              vm.tracker = $model;
              vm.trackerref = $model._id;
            }
            else {
              vm.tracker = {};
              vm.tracker.name = $model.name;
              vm.tracker.text = $model.text;
              vm.tracker.def = angular.copy($model.text.def);
              vm.tracker._id = $model._id;
              vm.trackerref = $model._id;
              vm.parentsave({tracker: vm.tracker, trackerref: vm.trackerref});
            }
          }

          function save() {
            if (!angular.equals(vm.tracker, vm.lasttracker) || !angular.equals(vm.trackerref, vm.lasttrackerref)) {
              vm.lasttracker = angular.copy(vm.tracker);
              vm.lasttrackerref = angular.copy(vm.trackerref);
              vm.parentsave({tracker: vm.tracker, trackerref: vm.trackerref});
            }
          }


        }] // controller
    }); // component

// klammerfriedhof
}());